import { z } from 'zod';

import { createEntityAdapterSchema } from '../../base';
import { TranslationSchema } from './translations.schema';

export const TranslationsSchema = z
  .object({
    translations: createEntityAdapterSchema(TranslationSchema),
  })
  .superRefine((data, context) => {
    const entries = Object.values(data.translations.entities);

    const seen: Record<string, string> = {};
    const duplicates: { id: string; translationKey: string }[] = [];

    for (const entry of entries) {
      if (!seen[entry.translationKey]) {
        seen[entry.translationKey] = entry.id;
        continue;
      }

      duplicates.push(entry);
    }

    for (const duplicate of duplicates) {
      context.addIssue({
        path: [
          'translations',
          'entities',
          seen[duplicate.translationKey],
          'translationKey',
        ],
        code: z.ZodIssueCode.custom,
        message: 'Duplicate translationKey',
      });
      context.addIssue({
        path: ['translations', 'entities', `${duplicate.id}`, 'translationKey'],
        code: z.ZodIssueCode.custom,
        message: 'Duplicate translationKey',
      });
    }
  });

export type Translations = z.infer<typeof TranslationsSchema>;
